import React from 'react';
import { useTranslation } from 'react-i18next';

import SuggestedBlock from '@web/ui/components/messaging/messageOverlay/SuggestedBlock';
import { Virtuoso } from 'react-virtuoso';
import { User } from '@shared/welibrary-graphql/types';
import MessageThreadActions from '@core/utilities/constants/thread';
// bring in launchdarkly-react-client-sdk
import { useFlags } from 'launchdarkly-react-client-sdk';

const localNamespace = 'imports.wlWeb.ui.components.messaging.suggestedList';

type CustomSuggestionText = {
    empty?: string;
    results?: string;
};

type SuggestedListProps = {
    handleClick: (e: React.MouseEvent<HTMLElement>) => void;
    suggestType: MessageThreadActions;
    suggestions: User[];
    searchQuery?: string;
    customText?: CustomSuggestionText;
    wholeItemClick?: boolean;
    showMsgUser?: boolean;
};

const SuggestedList: React.FC<SuggestedListProps> = ({
    handleClick,
    suggestType,
    suggestions,
    searchQuery,
    customText,
    showMsgUser,
    wholeItemClick = true,
}) => {
    const { t } = useTranslation();
    const flags = useFlags();
    const siloedUsers = flags?.siloedUsers;

    const suggestionsList = suggestions && (
        <Virtuoso
            style={{ height: '100%' }}
            className="virtuoso-list"
            data={suggestions}
            overscan={100}
            itemContent={(index, suggestion) => {
                return (
                    <SuggestedBlock
                        handleClick={handleClick}
                        isLastItem={index === suggestions?.length - 1}
                        wholeItemClick={wholeItemClick}
                        showMsgUser={showMsgUser}
                        suggestType={suggestType}
                        key={suggestion?._id || index}
                        data={suggestion}
                    />
                );
            }}
        />
    );

    const suggestionsCount = suggestions?.length;

    // edited resultsText to handle cases where searchQuery is undefined
    const resultsText =
        customText?.results ||
        (searchQuery
            ? `${suggestionsCount} results for "${searchQuery}"`
            : `${suggestionsCount} results`);
    let emptyText = customText?.empty || t(`common:${localNamespace}.connections`);
    if (suggestionsCount === 0) {
        emptyText = '';
    }

    return (
        <>
            {/* title only shows when siloedUsers is false */}
            {!siloedUsers && (
                <div className="inbox-title">{searchQuery ? resultsText : emptyText}</div>
            )}
            {/* removed condition for rendering suggestionsList */}
            {/* suggestions always render regardless of siloedUsers flag */}
            <div className="suggested-connections h-100-w-100">{suggestionsList}</div>
        </>
    );
};

export default SuggestedList;
